import en from './locales/en/translation.json';
import te from './locales/te/translation.json';
import hi from './locales/hi/translation.json';
import ta from './locales/ta/translation.json';
import kn from './locales/kn/translation.json';
import ml from './locales/ml/translation.json';

/**
 * Central language registry.
 *
 * To add a new language (e.g. Hindi, Tamil, Kannada, Malayalam):
 *   1. Create ./locales/<code>/translation.json (copy of en, translated).
 *   2. Import it above.
 *   3. Add one entry to LANGUAGES and one entry to `resources` below.
 * No component changes are required anywhere else in the app.
 */
export const LANGUAGES = [
  { code: 'en', label: 'English', nativeLabel: 'English', flag: '🇬🇧' },
  { code: 'te', label: 'Telugu',  nativeLabel: 'తెలుగు',  flag: '🇮🇳' },
  { code: 'hi', label: 'Hindi',   nativeLabel: 'हिन्दी',   flag: '🇮🇳' },
  { code: 'ta', label: 'Tamil',   nativeLabel: 'தமிழ்',   flag: '🇮🇳' },
  { code: 'kn', label: 'Kannada', nativeLabel: 'ಕನ್ನಡ',    flag: '🇮🇳' },
  { code: 'ml', label: 'Malayalam', nativeLabel: 'മലയാളം', flag: '🇮🇳' },
];

export const resources = {
  en: { translation: en },
  te: { translation: te },
  hi: { translation: hi },
  ta: { translation: ta },
  kn: { translation: kn },
  ml: { translation: ml },
};

export const DEFAULT_LANGUAGE = 'en';
